export enum EdocumentsOpened {
    pdf,
}